(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-gallery"]) return;
  try {
    


$('.grid-gallery').isotope({
  itemSelector: '.grid-item-media',
  percentPosition: true,
  masonry: {
    columnWidth: '.grid-sizer'
  }
});



  } catch(e) { console.error(e); }
})();
})();
